import { Subscription } from 'pages/Join/Join.types';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_URL } from 'src/environments/environment';
import Page from 'src/layout/Page';
import './join.css';
import { useTranslation } from 'react-i18next';

const Join: React.FC = (): React.ReactElement => {
  const [subscriptions, setSubscriptions] = useState<Subscription[]>([]);
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  useEffect(() => {
    const getData = async () => {
      const data = await fetch(`${API_URL}/subscriptions`, {
        method: 'GET',
      });
      const jsonData = await data.json();
      setSubscriptions(jsonData);
    };

    getData().then();
  }, []);

  const handleSubscribe = () => {
		if (i18n.language !== 'en') {
			navigate('/רישום');
		} else {
    navigate('/en/subscribe');
			}
  };

  return <Page pageClass={'join-page'}>
    <div className="subscriptions-list">
      {subscriptions.map((subscription) => (
        <div className={'subscription'} key={subscription.id}>
          <div className="subscription-details">
            <div className="subscription-name">
              {subscription.name
                ? subscription.name
                : `${subscription.lessonsCount} ${t('pages.join.lessonsCount')}`}
            </div>
            <div className="subscription-description">
              {subscription.description}
            </div>
          </div>
          <button
            className={'active continue-subscribe'}
            onClick={handleSubscribe}
          >
            {t('common.continue')}
          </button>
        </div>
      ))}
    </div>
  </Page>;
};

export default Join;
